// Форматирование чисел: латинские цифры, «–» вместо null (null ≠ 0), NaN и бесконечности.
export const DASH = '–';
export function fixed(value: number | null | undefined, digits: number): string {
  return value == null || !Number.isFinite(value) ? DASH : unsignedZero(value.toFixed(digits));
}
// Округлённый ноль («-0.000», «-0» у -0) пишем без знака.
function unsignedZero(text: string): string {
  return Number(text) === 0 ? text.replace(/^-/, '') : text;
}
export function signed(value: number, digits = 0): string {
  if (!Number.isFinite(value)) return DASH;
  const text = unsignedZero(value.toFixed(digits));
  return Number(text) > 0 ? `+${text}` : text;
}
